<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.00116 13.6395L9.00116 3.00119H11.0012L11.0012 13.6352L12.364 12.2718L13.5468 13.4536L10.0003 16.9989L8.2269 15.2274L6.45499 13.4536L7.63678 12.272L9.00116 13.6395Z"
    fill="currentColor"
  />
</svg>
